import type { NodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { useMemo } from 'react';
import { findVariableForChip, formatVariable } from './utils';
import { usePreviewVariables } from '../../../../../../providers/PreviewVariablesContext.tsx';

export const PreviewVariableNodeView = ({ node, getPos, editor }: NodeViewProps) => {
  const { variables } = usePreviewVariables();
  const currencySign = editor?.options?.editorProps.attributes?.['currencySign'];
  const variable = useMemo(
    () => findVariableForChip(variables, node.attrs as { name: string; objectId?: string | null; template?: string | null }),
    [variables, node.attrs.name, node.attrs.objectId, node.attrs.template]
  );

  const hasInlineValue = node.attrs.value !== null && node.attrs.value !== undefined;
  const valueToRender = hasInlineValue ? String(node.attrs.value) : variable ? formatVariable(node.attrs.name, variable, currencySign) : '';

  const onClick = () => {
    editor.chain().focus().setNodeSelection(getPos()).run();
  };

  return (
    <NodeViewWrapper
      data-type="variable"
      data-name={variable?.name ?? node.attrs.name ?? ''}
      as="span"
      className="tiptap-variable"
      style={{ whiteSpace: 'pre-wrap' }}
      onClick={onClick}
    >
      {valueToRender}
    </NodeViewWrapper>
  );
};
